/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { isNumber, values } from 'lodash';

export const AelEvents = {
  OfficeRolePermissions: {
    EditedGeneral: 4,
    EditedSetup: 5,
    EditedToDo: 6,
  },
  Office: {
    EditedContacts: 27,
    EditedFranchisee: 28,
    EditedEstimating: 45,
    EditedSales: 71,
    IntegrationAccounts: 80,
    EditedSalespersonBudgets: 103,
    EditedJobs: 134,
    EditedPrinters: 143,
    EditedCalendar: 154,
    EditedCriticalPath: 155,
    EditedReceivables: 184,
    EditedPayables: 185,
    EditedManager: 187,
    EditedSupervisor: 188,
    EditedLedger: 186,
    EditedAccountingReceivablesWip: 213,
    EditedAccountingJobExpense: 227,
    EditedAccountingOverhead: 228,
    EditedAccountingAdvertise: 229,
    EditedAccountingWages: 230,
    EditedAccountingLiabilities: 294,
    EditedVirtualSchedule: 231,
    WipPosted: 232,
    WipPostedNoJobs: 238,
    EomReportsEdited: 156,
    ProducedFranchiseMonthly: 233,
  },
  IntegrationAccounts: 159,
  MasterZone: {
    Edited: 104,
  },
  EmailTemplates: {
    System: 41,
    Job: {
      Create: 40,
      Edit: 42,
      Delete: 43,
    },
    Internal: 44,
    Layout: 58,
  },
  JobLetter: {
    Managed: 72,
  },
  SalesFolders: {
    Site: {
      Create: 86,
      Edit: 87,
      Delete: 88,
    },
    Quotation: {
      Create: 89,
      Edit: 90,
      Printed: 91,
      Approved: 92,
      Unapproved: 93,
      EDocsSent: 199,
    },
    SalesSchedule: {
      Created: 191,
      Edited: 192,
      Deleted: 235,
    },
  },
  Site: {
    Create: 94,
    Edit: 95,
    Delete: 96,
  },
  Quotation: {
    Create: 97,
    Edit: 98,
    Printed: 99,
    Approved: 100,
    Unapproved: 101,
  },
  ColorSelectionMaster: {
    MarkedAsDeleted: 116,
    Deleted: 117,
    Undeleted: 118,
    Created: 119,
    Edited: 120,
  },
  JobStage: {
    Create: 112,
    Edit: 113,
    Delete: 114,
    Undelete: 115,
  },
  JobSpec: {
    Edited: 124,
    Produced: 125,
  },
  Job: {
    ColorSelections: {
      Edited: 133,
      Produce: 239,
    },
    WarrantyTask: {
      Created: 150,
      Edited: 151,
      Deleted: 152,
    },
    JobOrder: {
      Produced: 153,
    },
    ConstructionSchedule: {
      Created: 189,
      Edited: 190,
      Deleted: 234,
    },
    PreConstructionSchedule: {
      Created: 193,
      Edited: 194,
      Deleted: 236,
    },
    MaintenanceSchedule: {
      Created: 195,
      Edited: 196,
      Deleted: 237,
    },
    ProgressDraw: {
      Created: 214,
      Reversed: 216,
    },
    ChangeOrderDraw: {
      Created: 215,
    },
    ChangeOrder: {
      Created: 221,
      Edited: 222,
      Approved: 223,
      Reversed: 224,
      Rejected: 225,
    },
  },
  EmailRecipients: 135,
  ChangeOrder: {
    Created: 138,
    Edited: 139,
    Approved: 140,
    Reversed: 141,
    Rejected: 142,
  },
  ScheduleTemplates: {
    Construction: {
      Created: 164,
      Edited: 165,
      Deleted: 166,
      MarkedAsDeleted: 167,
      Undeleted: 168,
    },
    Sales: {
      Created: 169,
      Edited: 170,
      Deleted: 171,
      MarkedAsDeleted: 172,
      Undeleted: 173,
    },
    PreCondition: {
      Created: 174,
      Edited: 175,
      Deleted: 176,
      MarkedAsDeleted: 177,
      Undeleted: 178,
    },
    Maintenance: {
      Created: 179,
      Edited: 180,
      Deleted: 181,
      MarkedAsDeleted: 182,
      Undeleted: 183,
    },
  },
  SubbiesSuppliers: {
    Edited: 160,
  },
  MilestoneEvent: {
    Created: 217,
    Edited: 218,
    Deleted: 219,
  },
  BaseDesign: {
    MarkedAsDeleted: 243,
    Deleted: 244,
    Undeleted: 245,
    Created: 246,
    Edited: 247,
  },
  Reports: {
    Rohc: {
      Edited: 250,
    },
    Fya: {
      Edited: 251,
    },
  },
};

export function getAelEventsArray(event: Hash<number> | number): number[] {
  return isNumber(event) ? [event] : values(event);
}
